import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

/**
 * Properties for the database UI ready command sent from the database iframe to the parent.
 */
export type DatabaseUIReadyCommandProperties = CommandProperties;

/**
 * Command sent from the database iframe to notify the parent application
 * that the database UI has finished rendering (both initial render and data loading complete).
 *
 * This allows the parent application to hide any loading overlays once the database
 * is fully ready for user interaction.
 */
export const DatabaseUIReadyCommand = createCommand<
  DatabaseUIReadyCommandProperties,
  void
>('database-ui-ready');
